import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const orderApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrders: builder.query<
      CommonResponse,
      { status?: number | undefined; page?: number | undefined }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.status !== undefined) {
          queryParams.append("status", String(params.status));
        }

        if (params?.page !== undefined) {
          queryParams.append("page", String(params.page));
        }

        const queryString = queryParams.toString();

        return {
          url: queryString
            ? `${END_POINTS.orders}?${queryString}`
            : END_POINTS.orders,
          method: "GET",
        };
      },
    }),

    getOrderById: builder.query<
      CommonResponse,
      { orderId: string | undefined }
    >({
      query: ({ orderId }) => ({
        url: `${END_POINTS.orders}/${orderId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetOrdersQuery, useLazyGetOrderByIdQuery } = orderApi;
